import Image from "next/image";
import Link from "next/link";
import { Dispatch, FC, SetStateAction } from "react";

const CategoryColumn: FC<{
  id: number;
  slug: string;
  image: string;
  name: string;
  description: string;
  setShowDropdown: Dispatch<SetStateAction<boolean>>;
}> = ({ description, id, image, name, slug, setShowDropdown }) => (
  <li key={id}>
    <Link
      href={`/products?category=${slug}`}
      onClick={() => setShowDropdown(false)}
      className="p-3 rounded-lg hover:bg-gray-100 flex items-center"
    >
      <Image
        src={image || "/img/default-category.png"}
        alt={name}
        height={60}
        width={60}
        className="mr-3 object-cover  aspect-square rounded-md"
      />
      <div className="w-[75%]">
        <div className="font-semibold truncate">{name}</div>
        <span className="text-sm text-gray-500 dark:text-gray-400 line-clamp-2 overflow-hidden break-words text-ellipsis">
          {description}
        </span>
      </div>
    </Link>
  </li>
);

export default CategoryColumn;
